import {
  AcceptType,
  ContentType,
  getRequest,
  postRequest,
} from '@utils/apiUtils';
import { AxiosResponse } from 'axios';

// portfolio type apis
export const postGetSecondaryMarketTransactionsList = (param: CapBayGetParams): Promise<AxiosResponse<CapBayApiData<CapBayTabularData<SecondaryMarket.SecondaryMarketTransactionData[]>>>> => {
  return postRequest('/p2p-admin/secondary-market/transaction', param);
};

export const getSecondaryMarketTransactionsListFilterOptions = () => {
  return getRequest<CapBayApiData<SecondaryMarket.SecondaryMarketTransactionsFilterOptions>>('/p2p-admin/secondary-market/transaction/filter-options');
};

export const downloadSecondaryMarketTransactionsExcelTemplate = () => {
  return getRequest<BlobPart>('/p2p-admin/secondary-market/transaction/download-template', {}, {
    responseType: 'blob',
    acceptType: AcceptType.JSON,
    contentType: ContentType.JSON,
  });
};

export const uploadSecondaryMarketTransactionsExcel = (param: FormData) => {
  return postRequest<SecondaryMarket.UploadSecondaryMarketTransactionsExcel>('/p2p-admin/secondary-market/transaction/upload', param);
};

export const postGetSecondaryMarketAllocationsList = (param: CapBayGetParams): Promise<AxiosResponse<CapBayApiData<CapBayTabularData<SecondaryMarket.SecondaryMarketAllocationData[]>>>> => {
  return postRequest('/p2p-admin/secondary-market/investment-allocation', param);
};

export const postGetSecondaryMarketAllocationsTree = (param: CapBayGetParams): Promise<AxiosResponse<CapBayApiData<CapBayTabularData<SecondaryMarket.SecondaryMarketAllocationNode[]>>>> => {
  return postRequest('/p2p-admin/secondary-market/investment-allocation/tree', param);
};

export const postGetSecondaryMarketChildAllocationsList = (investmentAllocationId: number): Promise<AxiosResponse<CapBayApiData<CapBayTabularData<SecondaryMarket.ChildInvestmentAllocationData[]>>>> => {
  return postRequest('/p2p-admin/secondary-market/investment-allocation/child', { investmentAllocationId });
};
